const RELOAD_ATTEMPT_KEY = 'app_update_reload_attempts'
const RELOAD_TIMESTAMP_KEY = 'app_update_reload_timestamp'
const MAX_RELOAD_ATTEMPTS = 3
const RELOAD_WINDOW_MS = 5 * 60 * 1000

export function getReloadAttempts() {
  try {
    const timestamp = sessionStorage.getItem(RELOAD_TIMESTAMP_KEY)
    if (timestamp && Date.now() - parseInt(timestamp, 10) > RELOAD_WINDOW_MS) {
      sessionStorage.removeItem(RELOAD_ATTEMPT_KEY)
      sessionStorage.removeItem(RELOAD_TIMESTAMP_KEY)
      return 0
    }
    return parseInt(sessionStorage.getItem(RELOAD_ATTEMPT_KEY), 10) || 0
  } catch {
    return 0
  }
}

export function incrementReloadAttempts() {
  try {
    const current = getReloadAttempts()
    sessionStorage.setItem(RELOAD_ATTEMPT_KEY, String(current + 1))
    sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()))
    return current + 1
  } catch {
    return 1
  }
}

export function clearReloadAttempts() {
  try {
    sessionStorage.removeItem(RELOAD_ATTEMPT_KEY)
    sessionStorage.removeItem(RELOAD_TIMESTAMP_KEY)
  } catch {
    /* ignore */
  }
}

export async function clearBrowserCaches() {
  const tasks = []

  if (typeof window !== 'undefined' && 'caches' in window) {
    tasks.push(
      window.caches
        .keys()
        .then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))))
        .catch(() => {}),
    )
  }

  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    tasks.push(
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
        .catch(() => {}),
    )
  }

  await Promise.race([
    Promise.allSettled(tasks),
    new Promise((resolve) => setTimeout(resolve, 3000)),
  ])
}

export function isStandaloneAppMode() {
  if (typeof window === 'undefined') {
    return false
  }

  const standaloneMatch =
    typeof window.matchMedia === 'function' &&
    (window.matchMedia('(display-mode: standalone)').matches ||
      window.matchMedia('(display-mode: fullscreen)').matches)

  return (
    standaloneMatch ||
    window.navigator?.standalone === true ||
    document.referrer.includes('android-app://')
  )
}

export function getMaxReloadAttempts() {
  return MAX_RELOAD_ATTEMPTS
}
